import api from './BaseApi';

export const getCountries = async () => {
    try {
        const response = await api.get('/locations/countries');
        return response.data;
    } catch (error) {
        console.error('Get Countries error:', error);
    }
};

export const getStates = async (countryId) => {
    try {
        const response = await api.get(`/locations/states/${countryId}`);
        return response.data;
    } catch (error) {
        console.error('Get States error:', error);
    }
};

export const getCities = async (stateId) => {
    try {
        const response = await api.get(`/locations/cities/${stateId}`);
        return response.data;
    } catch (error) {
        console.error('Get Cities error:', error);
    }
};

